import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import Card from '../../../components/Card';
import { Button } from 'primereact/button';
import { postApiCall } from '../../../service/postApiCall';
import { getApiCall } from '../../../service/getApiCall';
import { AGENT_GROUP_CREATE, API_AGENT_UPDATE, API_AGENT_GROUP_EXTENSION } from '../../../service/url';
import { useNavigate } from 'react-router-dom';
import ToastNotification from '../../../components/Toast';
import { Dropdown } from 'primereact/dropdown';
import { useLocation } from 'react-router-dom';
import { validateEmail } from '../../../utilities/helpers'
import { useParams } from 'react-router-dom';
import { MultiSelect } from 'primereact/multiselect';
import { toast } from 'react-toastify';
import { MODULE_ACL, FLASH_MESSAGE_ACTION_OBJECT} from '../../../utilities/constant';
import {fetchAndSetFlashMessage } from "../../../service/httpCall";


export default function EditAgent() {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const [agentName, setAgentName] = useState('');
    const [agentNumber, setAgentNumber] = useState('');
    const [selectedExtension, setSelectedExtension] = useState(null);
    const [emailId, setEmailId] = useState('');
    const [description, setDescription] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [access, setAccess] = useState(null);
    const [type, setType] = useState([]);
    const [loginStatus, setLoginStatus] = useState('');
    const [agentAllocatedExtension, setAgentAllocatedExtension] = useState(null);
    const [allExtensions, setAllExtensions] = useState([]);

    const [extensionOptions, setExtensionOptions] = useState([]);
    const [showToast, setShowToast] = useState(false);
    const [toastProps, setToastProps] = useState({ type: 'success', message: '' });
    const [emailError, setEmailError] = useState("");
    const [agentNameError, setAgentNameError] = useState("");
    const [usernameError, setUsernameError] = useState("");
    const [notes, setNotes] = useState([]);
    const [loading, setLoading] = useState(false);

    const accessOptions = [
        { label: 'Admin', value: 'Admin' },
        { label: 'Regular', value: 'Regular' },
        { label: 'Group Owner', value: 'Group Owner' },
    ];

    const typeOptions = [
        { label: 'Mobile', value: 'Mobile' },
        { label: 'Soft Phone', value: 'Soft Phone' },
        { label: 'WEBRTC', value: 'WEBRTC' },
    ];
    const loginStatusOptions = [
        { label: 'Active', value: '1' },
        { label: 'Inactive', value: '0' },
    ];



    // Fetch extensions for the dropdown
    useEffect(() => {
        getApiCall(`${API_AGENT_GROUP_EXTENSION}?data=all`)
            .then((data) => {
                // Store all extensions data
                setAllExtensions(data);
                
                let availableExtensions = data.filter(ext => ext.is_allocated == 0);
                const formatted = availableExtensions.map((ext) => ({
                    label: ext.username,
                    value: ext.id,
                }));

                setExtensionOptions([
                    { label: "Select Extension", value: null },
                    ...formatted
                ]);
            })
            .catch((error) => {
                console.error('Error fetching extensions:', error);
                // setToastProps({ type: 'danger', message: 'Error fetching extensions.' });
                toast.error("Error fetching extensions.");
                setShowToast(true);
            });

        fetchAndSetFlashMessage(
        msg => msg.module_name === MODULE_ACL.AGENTS && msg.action === FLASH_MESSAGE_ACTION_OBJECT.EDIT && msg.type === 'Note',
        setNotes
        );
    }, []);
  
    useEffect(() => {
        getApiCall(`${API_AGENT_UPDATE}/${id}`)
            .then((data) => {
                setAccess(data.access)
                setAgentName(data.agent_name)
                setAgentNumber(data.agent_number)
                setDescription(data.description)
                setEmailId(data.email_id)
                setType(data.type || [])
              
                setSelectedExtension(data.extensionId)

                if (data.extensionName) {
                    setAgentAllocatedExtension(data.extensionName);
                    
                    // Add the current extension to the options if it exists
                    const currentExtension = allExtensions.find(ext => ext.id === data.extensionId);
                    if (currentExtension) {
                        setExtensionOptions(prev => [
                            { label: "Select Extension", value: null },
                            { label: currentExtension.username, value: currentExtension.id },
                            ...prev.filter(opt => opt.value !== currentExtension.id && opt.value !== null)
                        ]);
                    }
                }
                setUsername(data.username)
                setLoginStatus(data.login_status)
            })
            .catch((error) => {
                console.error('Error fetching Agents:', error);
                // setToastProps({ type: 'danger', message: 'Error fetching Agents.' });
                toast.error("Error fetching Agents.");
                setShowToast(true);
            });
    }, [allExtensions]);


    const validateAgentName = (value) => {
      const trimmedValue = value.trim();
      if (!trimmedValue) {
        setAgentNameError("Agent Name is required");
        return false;
      }
      // Allow only letters, numbers, and underscores
      const nameRegex = /^[a-zA-Z0-9_]+$/;
      if (!nameRegex.test(trimmedValue)) {
        setAgentNameError("Agent Name can only contain letters, numbers, and underscores (_). No spaces or special characters allowed.");
        return false;
      }
      setAgentNameError("");
      return true;
    };

    const validateUsername = (value) => {
      const trimmedValue = value.trim();
      if (!trimmedValue) {
        setUsernameError("Username is required");
        return false;
      }
      // Allow only letters, numbers, and underscores
      const usernameRegex = /^[a-zA-Z0-9_]+$/;
      if (!usernameRegex.test(trimmedValue)) {
        setUsernameError("Username can only contain letters, numbers, and underscores (_). No spaces or special characters allowed.");
        return false;
      }
      setUsernameError("");
      return true;
    };

console.log(type)
    const handleEditAgent = async () => {
        if (loading) return;
        if (emailError) {
            // setToastProps({ message: "Enter correct Email", type: "danger" });
            toast.error("Enter correct Email.");
            return;
        }
        if (!validateAgentName(agentName)) {
          toast.error(agentNameError || "Agent Name validation failed");
          return;
        }
        if (!validateUsername(username)) {
          toast.error(usernameError || "Username validation failed");
          return;
        }

        let filteredType = type;
        if (!selectedExtension) {
            filteredType = type.filter(t => t != 'Soft Phone' && t != 'WEBRTC');
        }
        console.log(filteredType)
        if (!filteredType || filteredType?.length < 1) {
            toast.error("Type required");
            return;
        }

        const payload = {
            agent_name: agentName,
            agent_number: String(agentNumber),
            email_id: emailId,
            description,
            access,
            type: filteredType,
            login_status: loginStatus,
        };

        // if (!agentAllocatedExtension && selectedExtension) {
        //     payload.extension = selectedExtension;
        // }
         if(Array.isArray(type)&& !(type.includes('Soft Phone') ||type.includes('WEBRTC')) && selectedExtension){
          toast.error("Extension will be allocated only in case of Type Soft Phone or Type Webrtc.");
          return
        }
        if (selectedExtension && (Array.isArray(type) && type.includes("Soft Phone")  || type.includes("WEBRTC"))) {
            payload.extension = selectedExtension;
        }

        try {
            setLoading(true);
            await postApiCall(`${API_AGENT_UPDATE}/${id}`, payload);
            // setToastProps({ type: 'success', message: 'Agent updated successfully.' });
            toast.success("Agent Updated Successfully");
            setShowToast(true);
            setTimeout(() => navigate('/agents'), 2000);

        } catch (error) {
            const errorMessage =
                typeof error === "string"
                    ? error
                    : (error?.response?.data?.message || error?.message || String(error));
            const friendlyMessage = String(errorMessage).includes("Agent Number Already Exists")
                ? "Agent number must be unique. This number is already in use."
                : errorMessage;
            // setToastProps({ type: 'danger', message: errorMessage });
            toast.error(friendlyMessage);
            setShowToast(true);
        } finally {
            setLoading(false);
        }
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmailId(value);
        setEmailError(validateEmail(value));
    };

    return (
        <>
            <div style={{ marginTop: '20px' }}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-block justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">{'Edit Agent'}</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <form>
                                                       <Row className="mb-3">
                                        <Col md="12">
                                            <div className="alert alert-warning d-flex align-items-center" role="alert">
                                                <i className="fa fa-info-circle me-2" style={{color: '#856404'}}></i>
                                                <div>
                                                    {/* Extension will be allocated only in case of Type Soft Phone or Type Webrtc. */}
                                                    <strong>Note: </strong>{notes.find(n => Number(n.priority) === 1)?.message ?? ""}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md="4">
                                            <label htmlFor="agentName" className="form-label">Agent Name <span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                            <input
                                                type="text"
                                                id="agentName"
                                                value={agentName}
                                                onChange={(e) => {
                                                  const value = e.target.value;
                                                  setAgentName(value);
                                                  validateAgentName(value);
                                                }}
                                                onBlur={(e) => validateAgentName(e.target.value)}
                                                className={`form-control ${agentNameError ? 'is-invalid' : ''}`}
                                                placeholder="Agent Name"
                                                required
                                            />
                                            {agentNameError && <div className="invalid-feedback">{agentNameError}</div>}
                                        </Col>
                                        <Col md="4">
                                            <label htmlFor="agentNumber" className="form-label">Agent Number <span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                maxLength={10}
                                                id="agentNumber"
                                                value={agentNumber}
                                                onChange={(e) => {
                                                    const val = e.target.value;
                                                    if (/^\d{0,10}$/.test(val)) {
                                                        setAgentNumber(val);
                                                    }
                                                }}
                                                className="form-control"
                                                placeholder="Agent Number"
                                                required
                                            />
                                        </Col>
                                        <Col md="4">
                                            <label htmlFor="emailId" className="form-label">Email ID<span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                            <input
                                                type="email"
                                                id="emailId"
                                                value={emailId}
                                                onChange={handleEmailChange}
                                                className="form-control"
                                                placeholder="Email ID"
                                                required
                                            />
                                            {emailError && <span className="text-danger">{emailError}</span>}
                                        </Col>
                                    </Row>
                                    <Row className="mb-3" >
                                        <Col md="4">
                                            <label htmlFor="extension" className="form-label">Extension</label>
                                            <Dropdown
                                                id="extensionDropdown"
                                                value={selectedExtension}
                                                options={extensionOptions}
                                                onChange={(e) => {
                                                    setSelectedExtension(e.value);
                                                    // If extension is deselected, filter out Soft Phone and WEBRTC from type
                                                    if (!e.value) {
                                                        setType(prevType => prevType.filter(t => t !== 'Soft Phone' && t !== 'WEBRTC'));
                                                    }
                                                }}
                                                placeholder="Select Extension"
                                                className="form-control"
                                            />
                                        </Col>
                                        <Col md="4">
                                            <label htmlFor="username" className="form-label">Username<span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                            <input
                                                type="text"
                                                id="username"
                                                autoComplete="off"
                                                value={username}
                                                readOnly
                                                // onFocus={(e) => e.target.removeAttribute("readOnly")}
                                                onChange={(e) => {
                                                  const value = e.target.value;
                                                  setUsername(value);
                                                  validateUsername(value);
                                                }}
                                                onBlur={(e) => validateUsername(e.target.value)}
                                                className={`form-control ${usernameError ? 'is-invalid' : ''}`}
                                                placeholder="Username"
                                                required
                                            />
                                            {usernameError && <div className="invalid-feedback">{usernameError}</div>}
                                        </Col>
                                        {/* <Col md="4">
                                            <label htmlFor="password" className="form-label">Password</label>
                                            <input
                                                type="password"
                                                id="password"
                                                value={password}
                                                autoComplete="off"
                                                readOnly
                                                // onFocus={(e) => e.target.removeAttribute("readOnly")}
                                                onChange={(e) => setPassword(e.target.value)}
                                                className="form-control"
                                                placeholder="Password"
                                            />
                                        </Col> */}
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md="4">
                                            <label htmlFor="accessDropdown" className="form-label">Access<span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                            <Dropdown
                                                id="accessDropdown"
                                                value={access}
                                                options={accessOptions}
                                                style={{ height: "50%", alignItems: "center" }}
                                                onChange={(e) => setAccess(e.value)}
                                                placeholder="Select Access"
                                                className="form-control"
                                            />
                                        </Col>
                                        <Col md="5">
                                            <label htmlFor="typeDropdown" className="form-label">Type<span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                            <MultiSelect
                                                id="typeDropdown"
                                                value={type}
                                               options={
                                                    !selectedExtension
                                                        ? [{ label: 'Mobile', value: 'Mobile' }]
                                                        : typeOptions
                                                }
                                                onChange={(e) => {
                                                    let newValue = e.value;
                                                    if (!selectedExtension) {
                                                           newValue = e.value.filter(t => t === 'Mobile');
                                                    }
                                                    setType(newValue);
                                                }}
                                                placeholder="Select Type"
                                                className="form-control"
                                                display="chip"
                                                style={{ height: "50%", alignItems: "center" }}
                                              
                                            />
                                        </Col>
                                        {/* <Col md="4">
                                            <label htmlFor="loginStatusDropdown" className="form-label">Login Status</label>
                                            <Dropdown
                                            style={{height:"50%",alignItems:"center"}}
                                                id="loginStatusDropdown"
                                                value={loginStatus}
                                                options={loginStatusOptions}
                                                onChange={(e) => setLoginStatus(e.value)}
                                                placeholder="Select Login Status"
                                                className="form-control"
                                            />
                                        </Col> */}
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md="12">
                                            <label htmlFor="description" className="form-label">Description</label>
                                            <textarea
                                                id="description"
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                                className="form-control"
                                                placeholder="Description"
                                                rows="3"
                                            ></textarea>
                                        </Col>
                                    </Row>
                                    <Button
                                        label={loading ? 'Updating...' : 'Update'}
                                        onClick={handleEditAgent}
                                        className="p-button-danger mt-3"
                                        type="button"
                                        disabled={loading}
                                    />
                                </form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}
        </>
    );
}
